import { ApplicationStatus } from '@flowx/designer/shared/entities/application.entity'

export enum ExceptionSourceEnum {
  ACTION = 'ACTION',
  NODE = 'NODE',
  SUBPROCESS = 'SUBPROCESS',
  PROCESS_DEFINITION = 'PROCESS_DEFINITION',
}

export enum ExceptionTypeEnum {
  BUSINESS_RULE_EVALUATION_EXCEPTION = 'BUSINESS_RULE_EVALUATION_EXCEPTION',
  ACTION_EVALUATION_EXCEPTION = 'ACTION_EVALUATION_EXCEPTION',
  MAPPER_EVALUATION_EXCEPTION = 'MAPPER_EVALUATION_EXCEPTION',
  ENGINE_EXCEPTION = 'ENGINE_EXCEPTION',
  DEFINITION_EXCEPTION = 'DEFINITION_EXCEPTION',
  GATEWAY_EVALUATION_EXCEPTION = 'GATEWAY_EVALUATION_EXCEPTION',
  SUBPROCESS_EXCEPTION = 'SUBPROCESS_EXCEPTION',
  NODE_EXCEPTION = 'NODE_EXCEPTION',
}
export const ExceptionTypeMappings = {
  [ExceptionTypeEnum.BUSINESS_RULE_EVALUATION_EXCEPTION]: 'Business Rule',
  [ExceptionTypeEnum.ACTION_EVALUATION_EXCEPTION]: 'Action Evaluation',
  [ExceptionTypeEnum.MAPPER_EVALUATION_EXCEPTION]: 'Integration Mapper',
  [ExceptionTypeEnum.ENGINE_EXCEPTION]: 'Engine Exception',
  [ExceptionTypeEnum.DEFINITION_EXCEPTION]: 'Process Definition',
  [ExceptionTypeEnum.NODE_EXCEPTION]: ' Node Definition',
  [ExceptionTypeEnum.GATEWAY_EVALUATION_EXCEPTION]: 'Gateway Evaluation',
  [ExceptionTypeEnum.SUBPROCESS_EXCEPTION]: 'Subprocess Exception',
}

export interface ProcessExceptionsQueryParams {
  instanceUuid: string
  fromDate: string
  beforeDate: string
  resourceDefinitionId: string
  type: ExceptionTypeEnum
  applicationId: string
}

export interface ProcessException {
  id: number
  buildStatusAtStart: ApplicationStatus
  processId: number
  resourceDefinitionId: string
  resourceId: string
  processDefinitionName: string
  processInstanceUuid: string
  processInstanceId: number
  tokenInstanceUuid: string
  tokenInstanceId: number
  parentInstanceId: null
  subprocessInstanceUuid: null
  date: string
  type: string
  source: string
  causeId: number
  causeName: string
  causeType: string
  details: string
  message: string
  formattedSource: string
  formattedType: string
}
